import { render, staticRenderFns } from "./add-customer-point-modal.vue?vue&type=template&id=2a940879"
import script from "./add-customer-point-modal.vue?vue&type=script&lang=js"
export * from "./add-customer-point-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports